import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = null as any;

const isReadOnlyStateSlice = createSlice({
	name: 'isReadOnlyState',
	initialState,
	reducers: {
		setIsReadOnlyState: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		}
	}
});

export const { setIsReadOnlyState } = isReadOnlyStateSlice.actions;

export default isReadOnlyStateSlice.reducer;
